import { useEffect, useState } from "react";
import { AxiosPublico } from "../../../componentes/axios/Axios";
import Card from "../../../componentes/contenedores/Card";
import Page from "../../../componentes/plantillaInicio/Page";
import { InvernaderoListar, InvernaderoListarEmpresa } from "../../../configuracion/apiUrls";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import { useNavigate } from "react-router-dom";

const HomeInvenaderos = () => {
    const { setInvernaderoSeleccionado, usuario } = useContextUsuario();
    const navigate = useNavigate();

    const datos = {
        titulo: {
            titulo: "Gestión de Invernaderos",
            url: "/app/admin/invernaderos/",
            tituloUrl: "Menú Principal",
            nombreUrl: "Invernaderos",
        },
    };

    const [invernaderos, setInvernaderos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (usuario && usuario.empresa) {
            obtenerInvernaderosPorEmpresa(usuario.empresa.id);
        }
    }, [usuario]);

    const obtenerInvernaderosPorEmpresa = async (empresaId) => {
        try {
            setLoading(true);
            const { data } = await AxiosPublico.get(`${InvernaderoListarEmpresa}?empresaId=${empresaId}`);
            setInvernaderos(data);
        } catch (error) {
            console.error("Error al obtener invernaderos", error);
        } finally {
            setLoading(false);
        }
    };

    const formatearFecha = (fecha) => {
        return new Date(fecha).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const renderInvernaderos = () => {
        if (loading) {
            return (
                <div className="col-12 text-center my-5">
                    <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                    <p className="mt-3 text-muted">Cargando invernaderos...</p>
                </div>
            );
        }

        if (invernaderos.length === 0) {
            return (
                <div className="col-12 text-center my-5">
                    <div className="alert alert-info border-0 shadow-sm" role="alert">
                        <i className="bi bi-info-circle me-2"></i>
                        No hay invernaderos registrados.
                    </div>
                </div>
            );
        }

        return invernaderos.map((invernadero) => (
            <div key={invernadero.id} className="col-12 col-md-6 col-xl-4 mb-4">
                <div className="card h-100 shadow-sm border-0 rounded-4">
                    <div className="card-header bg-success text-white rounded-top-4 d-flex justify-content-between align-items-center p-3">
                        <h5 className="card-title mb-0 fw-bold fs-6">
                            <i className="bi bi-house-gear me-2"></i>
                            {invernadero.descripcion}
                        </h5>
                        <span className={`badge ${invernadero.estado === 'Activo' ? 'bg-light text-success' : 'bg-danger text-white'} fs-7`}>
                            {invernadero.estado}
                        </span>
                    </div>

                    <div className="card-body d-flex flex-column p-4">
                        <div className="mb-3">
                            <p className="card-text mb-2">
                                <i className="bi bi-geo-alt-fill text-primary me-2"></i>
                                <span className="fw-semibold">Ubicación:</span> {invernadero.ubicacion}
                            </p>
                            <p className="card-text mb-2">
                                <i className="bi bi-hash text-secondary me-2"></i>
                                <span className="fw-semibold">ID:</span> {invernadero.id}
                            </p>
                        </div>

                        {invernadero.invernaderoTelefonos?.length > 0 && (
                            <div className="mb-3">
                                <h6 className="text-primary mb-2 border-bottom pb-1">
                                    <i className="bi bi-telephone-fill me-2"></i>
                                    Contactos:
                                </h6>
                                <ul className="list-unstyled mb-0">
                                    {invernadero.invernaderoTelefonos.map((contacto, index) => (
                                        <li key={index} className="d-flex justify-content-between align-items-center bg-light rounded-pill p-2 mb-1">
                                            <span className="fw-normal text-truncate me-2">{contacto.contacto}</span>
                                            <a href={`tel:${contacto.telefono}`} className="text-decoration-none">
                                                <span className="badge bg-primary text-white">{contacto.telefono}</span>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {invernadero.InvernaderoDireccions?.length > 0 && (
                            <div className="mb-3">
                                <h6 className="text-primary mb-2 border-bottom pb-1">
                                    <i className="bi bi-map-fill me-2"></i>
                                    Direcciones:
                                </h6>
                                <ul className="list-unstyled mb-0">
                                    {invernadero.InvernaderoDireccions.map((dir, index) => (
                                        <li key={index} className="bg-light rounded p-2 mb-1 small text-muted">
                                            {dir.direccion}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        <div className="mt-auto border-top pt-3">
                            <small className="text-muted d-block">
                                <i className="bi bi-calendar-plus me-1"></i>
                                Creado: {formatearFecha(invernadero.createdAt)}
                            </small>
                            <small className="text-muted d-block">
                                <i className="bi bi-calendar-check me-1"></i>
                                Actualizado: {formatearFecha(invernadero.updatedAt)}
                            </small>
                        </div>
                    </div>

                    <div className="card-footer bg-light border-0 text-center p-3">
                        <button
                            className="btn btn-primary w-100 fw-bold"
                            onClick={() => {
                                setInvernaderoSeleccionado(invernadero);
                                localStorage.setItem("invernaderoId", invernadero.id);
                                navigate("/app/admin/resumen");
                            }}
                        >
                            <i className="bi bi-check-circle me-1"></i>
                            Seleccionar
                        </button>
                    </div>
                </div>
            </div>
        ));
    };

    return (
        <Page datos={datos}>
            <Card titulo="Lista de Invernaderos">
                <div className="row g-4">
                    {renderInvernaderos()}
                </div>

                {!loading && invernaderos.length > 0 && (
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="p-3 bg-light rounded-4 shadow-sm border">
                                <div className="row text-center g-3">
                                    <div className="col-6 col-md-3">
                                        <h4 className="text-primary mb-0 fw-bold">{invernaderos.length}</h4>
                                        <small className="text-muted">Total de Invernaderos</small>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <h4 className="text-success mb-0 fw-bold">
                                            {invernaderos.filter(inv => inv.estado === 'Activo').length}
                                        </h4>
                                        <small className="text-muted">Activos</small>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <h4 className="text-danger mb-0 fw-bold">
                                            {invernaderos.filter(inv => inv.estado !== 'Activo').length}
                                        </h4>
                                        <small className="text-muted">Inactivos</small>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <h4 className="text-info mb-0 fw-bold">
                                            {invernaderos.reduce((total, inv) => total + (inv.invernaderoTelefonos?.length || 0), 0)}
                                        </h4>
                                        <small className="text-muted">Contactos Totales</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Card>
        </Page>
    );
};

export default HomeInvenaderos;